import { axiosClient } from '../axiosClient';

export const deleteReferral = async (referralId: number) => {
  return axiosClient.delete(`/referrals/${referralId}`);
};
